/**
 * ARIA labels for accessibility.
 */
export const sidebarAriaLabels = {
  closeSidebar: () => $localize`:@@sidebar.aria.close:Sidebar schließen`,
  filterSidebar: () =>
    $localize`:@@sidebar.aria.filter:Filter Sidebar schließen`,
  filterReset: () =>
    $localize`:@@sidebar.aria.filter-reset:Alle Filter zurücksetzen`,
  filterApply: () =>
    $localize`:@@sidebar.aria.filter-apply:Filter anwenden und schließen`,
} as const;
